import { render, staticRenderFns } from "./KeyLocations.vue?vue&type=template&id=276f4b33&"
import script from "./KeyLocations.vue?vue&type=script&lang=ts&"
export * from "./KeyLocations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports